/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LedgerPaidBy/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import LedgerPaymentAccount from 'DesignSystem/LedgerPaymentAccount/index'
import PaymentMethod from './PaymentMethod/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ReturnIcon from 'DesignSystem/Svgs/Tysiav2ReturnIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LedgerPaidBy({
  children,
  viewPath = "/DesignSystem/LedgerPaidBy",
  onSubmit
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let paymentPaymentTypeValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'payment_type',
})
let constantData = 'Autopay'
let aggregateData = fromAggregate.equals(paymentPaymentTypeValueData, constantData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let paymentAccountValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'account',
})
let paymentSubmitData = fromData.useDataSubmit({ viewPath,
context: 'payment',
})
  return (<React.Fragment
>
<div
  data-testid="LedgerPaidBy.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-11vUV6': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2ReturnIcon
  viewPath={`${viewPath}/Tysiav2ReturnIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 text={aggregateData ? "Autopaid by" : "Paid by"}
 data="payment.payment_type"
 data="'Autopay'"
 aggregate="/Data/aggregate.js equals"
/>
<LedgerPaymentAccount
  viewPath={`${viewPath}/LedgerPaymentAccount`}
 data="payment.account"
 value={paymentAccountValueData}
 data="payment"
 onClick={paymentSubmitData}
/>
<PaymentMethod
  viewPath={`${viewPath}/PaymentMethod`}
/>
</div>
{children}
</React.Fragment>)
}